import { NotificationService } from './../../../services/notification.service';
import { WebService } from './../../../services/web.service';
import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { CommonRequestResponseService } from './../../../services/common-request-response.service';



@Component({
  selector: 'reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})

export class ResetPasswordComponent {

  email: string;
  isValidEmail = true;

  constructor(
    public bsModalRef: BsModalRef,
    private webService: WebService,
    private notificationService: NotificationService,
    private _commonRequestResponseService: CommonRequestResponseService,

  ) {}

  // Create request for password reset
  submit(form) {

    if (!form.valid) {
      this.isValidEmail = false;
    } else {

    // need refactoring
    const data = {
      targetUserId: 0,
      isReset: true,
      emailAddress: this.email // needed param
    };

    this._commonRequestResponseService.postWithHeader('coach/accountinfo/passwordreset', data)
      .subscribe(
        () => {
          this.notificationService.show('success', 'Reset link has been sent to your email');
        },
        (error) => {
        //  this.notificationService.show('error', 'Error While resetting password');
          this.notificationService.show('error', error.error.errorMessage.replace('Failed to get AccountInfoPasswordReset :', ''));
        },
        () => {
          this.bsModalRef.hide();
        });
    }
  }
}
